import {alpha, styled} from '@mui/material/styles';
import Tree from '@ennabl/rc-tree';
import {FC} from 'react';

import {styleVariables} from 'core/constants';

import CheckboxUncheckedIcon from 'components/icons/checkboxUnchecked.svg';
import CheckboxIndeterminateIcon from 'components/icons/checkboxIndeterminate.svg';
import CheckboxCheckedIcon from 'components/icons/checkboxChecked.svg';

export const STreeWrapper = styled('div')`
  background-color: ${styleVariables.colorWhite};
`;

export const STree = styled(Tree)`
  border: 0;

  && .rc-tree-indent-unit {
    width: 32px;
  }

  && .rc-tree-treenode .rc-tree-node-content-wrapper {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 16px 8px;
  }

  && .rc-tree-treenode {
    display: flex;
    align-items: center;
    height: 52px;
    padding: 0 12px;
    border-radius: 0;
    border: 1px solid ${({theme}) => theme.palette.divider};

    &:not(:last-of-type) {
      border-bottom: 0;
    }

    &:first-of-type {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    &:last-of-type {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    &:not(.rc-tree-treenode-checkbox-checked):not(.rc-tree-treenode-selected):not(.rc-tree-treenode-disabled) {
      &:hover {
        background-color: ${({theme}) => alpha(theme.palette.primary.main, 0.08)};
      }

      .rc-tree-node-content-wrapper:hover {
        color: ${({theme}) => theme.palette.primary.main};
      }
    }

    &.rc-tree-treenode-disabled {
      cursor: default;
    }
  }

  .rc-tree-switcher:hover {
    color: ${({theme}) => theme.palette.primary.main};
  }

  && .rc-tree-treenode-checkbox-checked,
  && .rc-tree-treenode-selected {
    background-color: ${({theme}) => alpha(theme.palette.primary.main, 0.08)};
    color: ${({theme}) => theme.palette.primary.main};
  }

  && .rc-tree-node-selected {
    background: unset;
    box-shadow: unset;
    opacity: unset;
  }

  && .rc-tree-title {
    flex: 1 1 auto;
  }

  && .rc-tree-treenode span.rc-tree-switcher,
  && .rc-tree-treenode span.rc-tree-checkbox,
  && .rc-tree-treenode span.rc-tree-iconEle {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    line-height: 20px;
  }

  && .rc-tree-treenode span.rc-tree-switcher {
    margin: 0 8px 0 0;
    width: 20px;
    height: auto;
    display: grid;
    place-items: center;
    flex-shrink: 0;

    &.rc-tree-switcher-noop {
      width: 20px;
    }
  }

  && .rc-tree-treenode span.rc-tree-checkbox {
    width: 16px;
    height: 16px;
    margin: 0 8px 0 0;
    display: flex;
    align-items: center;
  }

  && .rc-tree-treenode-disabled span.rc-tree-checkbox,
  && .rc-tree-treenode-disabled .rc-tree-title {
    opacity: 0.5;
  }

  && .rc-tree-treenode span.rc-tree-checkbox.rc-tree-checkbox-indeterminate.rc-tree-checkbox-disabled {
    background: transparent;
  }

  && .rc-tree-treenode span.rc-tree-iconEle {
    display: none;
  }
` as any as FC<any>;

export const SCheckboxUnchecked = styled(CheckboxUncheckedIcon)`
  .rc-tree-checkbox-indeterminate &,
  .rc-tree-checkbox-checked & {
    display: none;
  }
`;

export const SCheckboxIndeterminate = styled(CheckboxIndeterminateIcon)`
  display: none;

  .rc-tree-checkbox-indeterminate & {
    display: block;
  }
`;

export const SCheckboxChecked = styled(CheckboxCheckedIcon)`
  display: none;

  .rc-tree-checkbox-checked & {
    display: block;
  }
`;

export const STitleWrapper = styled('div')`
  display: grid;
  grid-template-columns: auto min-content;
  grid-gap: 8px;
  align-items: center;
`;
